import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { PermissionsContext } from "../utils/PermissionsContext";

const ProtectedRoute = ({ element, requiredPermission }) => {
  const permissions = useContext(PermissionsContext);

  if (!permissions.includes(requiredPermission)) {
    return <Navigate to="/home" replace />;
  }

  return element;
};

export default ProtectedRoute;
